import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Box,
  ImageListItem,
  Divider,
  ListItemButton,
  colors,
  MobileStepper,
  Button,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useParams } from "react-router-dom";
import { CustomTextField } from "../../../components/InputFields/TextFields";
import { CustomFileInput } from "../../../components/InputFields/CustomFileInput/CustomFileInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import { stringValidationSchema } from "../../../constant/validationSchema";
import {
  Add,
  AttachFile,
  Close,
  Delete,
  Edit,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  UploadFile,
} from "@mui/icons-material";
import CustomButton from "../../../components/ActionButtons/CustomButton";
import { CustomDialogWrapper } from "../../../components/Wrappers/CustomDialogWrapper";
import ApiClient from "../../../constant/API_URLS";
import { NoResultFound } from "../../../components/NoResult/NoResult";
import { LoadingEffect } from "../../../components/SimmerEffects/LoadingEffect";
import { ReadableDateTime } from "../../../utils/ReadableDateTime";
import { convertToFormData } from "../../../utils/ConvertToFormData";
import CustomToaster from "../../../utils/CustomToaster";
import { ThemeColors } from "../../../constant/ThemeColors";
import { CustomPopover } from "../../../components";
import { DeleteConfirmationDialog } from "../../../components/DeleteDetails/DeleteConfirmationDialog";
import CustomCheckBox from "../../../components/InputFields/CustomCheckBox/CustomCheckBox";
import dayjs from "dayjs";
import { GET_USER } from "../../../utils/LocalStorageGetSet";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";

const FallBackImage = () => {
  return;
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="160"
    height="160"
    viewBox="0 0 160 160"
  >
    <rect width="100%" height="100%" fill="#DDDDDD" />
    <path
      fill="#999999"
      d="M34.1 75.985h-3.85v2.4h3.03v1.25h-3.03v2.45h3.85v1.29h-5.47v-8.68h5.47v1.29Zm2.5 1.61.09.69q.29-.55.69-.87.39-.31.93-.31.43 0 .69.19l-.1 1.11q-.03.1-.09.15-.05.04-.15.04-.09 0-.27-.03-.17-.03-.34-.03-.25 0-.44.08-.19.07-.34.2-.16.14-.27.33-.12.19-.22.44v3.79h-1.49v-6.16h.87q.23 0 .32.08.09.09.12.3Zm4.48 0 .09.69q.29-.55.68-.87.4-.31.94-.31.42 0 .68.19l-.09 1.11q-.03.1-.09.15-.06.04-.15.04t-.27-.03q-.18-.03-.35-.03-.24 0-.43.08-.2.07-.35.2-.15.14-.27.33-.12.19-.22.44v3.79h-1.48v-6.16h.87q.23 0 .32.08.09.09.12.3Zm5.89-.47q.68 0 1.25.22.56.22.96.63.39.41.61 1 .22.58.22 1.31 0 .73-.22 1.32-.22.59-.61 1-.4.42-.96.64-.57.22-1.25.22-.69 0-1.25-.22-.57-.22-.97-.64-.4-.41-.61-1-.22-.59-.22-1.32 0-.73.22-1.31.21-.59.61-1 .4-.41.97-.63.56-.22 1.25-.22Zm0 5.2q.77 0 1.14-.52.37-.51.37-1.51 0-.99-.37-1.52-.37-.52-1.14-.52-.78 0-1.15.53-.38.52-.38 1.51t.38 1.51q.37.52 1.15.52Zm5.48-4.73.09.69q.29-.55.68-.87.4-.31.94-.31.42 0 .68.19l-.09 1.11q-.03.1-.09.15-.06.04-.15.04t-.27-.03q-.18-.03-.35-.03-.24 0-.43.08-.2.07-.35.2-.15.14-.27.33-.12.19-.22.44v3.79h-1.48v-6.16h.87q.23 0 .32.08.09.09.12.3Zm6.13-.38h1.49v6.16h-1.49v-6.16Zm1.69-1.79q0 .19-.08.36-.07.17-.2.29-.13.13-.31.21-.17.07-.37.07-.19 0-.36-.07-.17-.08-.3-.21-.12-.12-.2-.29-.07-.17-.07-.36 0-.2.07-.37.08-.18.2-.3.13-.13.3-.2.17-.08.36-.08.2 0 .37.08.18.07.31.2.13.12.2.3.08.17.08.37Zm2.79 7.95h-1.48v-6.16h.91q.28 0 .37.27l.1.46q.16-.18.34-.33.18-.15.38-.26.2-.11.43-.17.23-.06.51-.06.58 0 .95.31.38.32.56.84.15-.31.36-.53.22-.21.48-.35.26-.14.55-.21.29-.06.58-.06.51 0 .91.15.39.16.66.46.27.3.42.73.14.43.14.99v3.92h-1.49v-3.92q0-.59-.25-.88-.26-.3-.76-.3-.23 0-.42.08-.2.08-.34.22-.15.15-.24.37-.08.22-.08.51v3.92h-1.49v-3.92q0-.62-.25-.9t-.73-.28q-.32 0-.6.16-.28.16-.52.43v4.51Zm11.82-1.59v-1.04q-.64.03-1.08.11-.44.08-.7.21-.26.13-.38.29-.11.17-.11.37 0 .39.23.56.23.17.6.17.46 0 .79-.17.33-.16.65-.5Zm-3.13-3.23-.26-.48q1.06-.97 2.55-.97.54 0 .97.18.42.17.72.49.29.31.45.75.15.44.15.96v3.89h-.67q-.21 0-.33-.06-.11-.07-.18-.26l-.13-.44q-.23.21-.46.37-.22.16-.46.26-.24.11-.51.17-.27.06-.6.06-.39 0-.72-.11-.33-.1-.57-.31-.24-.21-.38-.53-.13-.31-.13-.72 0-.24.08-.47.08-.23.26-.44.17-.21.45-.39.29-.19.7-.33t.95-.22q.55-.09 1.25-.11v-.36q0-.62-.26-.91-.27-.3-.76-.3-.36 0-.6.08-.24.09-.42.19-.18.11-.32.19-.15.09-.33.09-.16 0-.27-.08-.1-.09-.17-.19Zm8.22 1.59q.28 0 .48-.07.2-.08.34-.21.13-.13.2-.32.07-.18.07-.41 0-.45-.27-.72-.27-.27-.82-.27-.55 0-.82.27-.27.27-.27.72 0 .22.07.41.07.18.2.32.14.13.34.21.21.07.48.07Zm1.67 3.51q0-.18-.1-.3-.11-.11-.3-.18-.18-.06-.43-.09t-.53-.04q-.28-.02-.58-.03-.29-.01-.58-.05-.24.14-.39.33-.16.18-.16.43 0 .16.08.3.08.14.26.24.18.11.46.16.28.06.69.06.41 0 .71-.06.3-.07.5-.18.19-.11.28-.26.09-.15.09-.33Zm-.29-6.23h1.77v.56q0 .26-.32.32l-.55.1q.13.32.13.7 0 .45-.19.82-.18.37-.5.63-.33.26-.77.4t-.95.14q-.18 0-.35-.02-.17-.02-.33-.05-.29.18-.29.39 0 .19.18.28.17.08.45.12.28.04.64.04.36.01.74.04t.74.11q.36.07.64.24.28.16.45.44.17.28.17.71 0 .41-.2.8-.2.38-.58.68-.38.3-.94.48-.55.19-1.26.19-.7 0-1.21-.14-.52-.13-.86-.36-.34-.22-.51-.52-.17-.29-.17-.61 0-.43.26-.72t.72-.47q-.25-.12-.39-.33-.14-.21-.14-.56 0-.13.05-.28.05-.15.15-.29.1-.15.25-.28.15-.12.35-.23-.47-.25-.73-.67-.27-.42-.27-.98 0-.46.18-.83.18-.37.51-.63t.78-.4q.44-.13.97-.13.4 0 .74.08.35.08.64.23Zm3.88 2.16h2.79q0-.28-.08-.54-.08-.25-.24-.45-.16-.19-.41-.3-.25-.11-.58-.11-.64 0-1.01.37-.37.36-.47 1.03Zm3.78.9H85.2q.03.47.16.82.14.34.35.57.22.22.52.33.29.11.65.11.36 0 .62-.08t.46-.19l.34-.18q.15-.09.29-.09.18 0 .27.14l.43.54q-.25.29-.55.49-.31.19-.64.31-.34.11-.68.16-.35.05-.67.05-.64 0-1.19-.21-.56-.22-.96-.63-.41-.42-.65-1.04-.23-.61-.23-1.42 0-.63.2-1.19.21-.55.59-.96.38-.41.93-.65.55-.24 1.24-.24.58 0 1.07.18.49.19.85.55.35.35.55.87.2.52.2 1.19 0 .33-.07.45t-.27.12Zm4.39-6.03h1.48v8.92H93.4v-8.92Zm5.69 2.67q.68 0 1.24.22.56.22.96.63.4.41.62 1 .21.58.21 1.31 0 .73-.21 1.32-.22.59-.62 1-.4.42-.96.64-.56.22-1.24.22-.69 0-1.26-.22-.56-.22-.96-.64-.4-.41-.62-1-.22-.59-.22-1.32 0-.73.22-1.31.22-.59.62-1 .4-.41.96-.63.57-.22 1.26-.22Zm0 5.2q.76 0 1.13-.52.37-.51.37-1.51 0-.99-.37-1.52-.37-.52-1.13-.52-.78 0-1.16.53-.37.52-.37 1.51t.37 1.51q.38.52 1.16.52Zm7.42-.54v-1.04q-.64.03-1.08.11-.44.08-.7.21-.27.13-.38.29-.12.17-.12.37 0 .39.24.56.23.17.6.17.45 0 .79-.17.33-.16.65-.5Zm-3.13-3.23-.27-.48q1.06-.97 2.56-.97.54 0 .96.18.43.17.72.49.3.31.45.75.15.44.15.96v3.89h-.67q-.21 0-.32-.06-.12-.07-.18-.26l-.13-.44q-.24.21-.46.37-.22.16-.46.26-.24.11-.51.17-.28.06-.61.06-.39 0-.72-.11-.33-.1-.57-.31-.24-.21-.37-.53-.13-.31-.13-.72 0-.24.08-.47.07-.23.25-.44t.46-.39q.28-.19.69-.33.41-.14.96-.22.55-.09 1.25-.11v-.36q0-.62-.27-.91-.26-.3-.76-.3-.36 0-.59.08-.24.09-.42.19-.18.11-.33.19-.15.09-.33.09-.15 0-.26-.08-.11-.09-.17-.19Zm9.83 3v-2.76q-.25-.31-.55-.44-.3-.12-.64-.12-.33 0-.6.12-.27.13-.47.39-.19.25-.29.64-.1.4-.1.93 0 .54.09.91.08.38.24.62.17.23.4.34.23.1.52.1.46 0 .79-.19.32-.19.61-.54Zm0-7.1h1.48v8.92h-.9q-.3 0-.38-.27l-.12-.59q-.37.42-.86.69-.48.26-1.12.26-.51 0-.93-.21-.42-.21-.72-.61t-.47-.99q-.16-.58-.16-1.34 0-.68.18-1.27.19-.59.54-1.02.35-.43.83-.68.49-.24 1.09-.24.52 0 .89.16.36.16.65.44v-3.25Zm2.99 2.76h1.49v6.16h-1.49v-6.16Zm1.7-1.79q0 .19-.08.36-.08.17-.21.29-.13.13-.3.21-.18.07-.37.07-.2 0-.37-.07-.17-.08-.29-.21-.13-.12-.2-.29-.08-.17-.08-.36 0-.2.08-.37.07-.18.2-.3.12-.13.29-.2.17-.08.37-.08.19 0 .37.08.17.07.3.2.13.12.21.3.08.17.08.37Zm2.59 2.06.1.49q.19-.19.39-.35.21-.15.44-.27.23-.11.5-.17.26-.06.57-.06.51 0 .9.17t.65.48q.26.31.39.74.14.43.14.94v3.92h-1.48v-3.92q0-.56-.26-.87-.26-.31-.79-.31-.38 0-.72.17-.33.18-.63.48v4.45h-1.49v-6.16h.91q.29 0 .38.27Zm7.73 2.66q.28 0 .48-.07.21-.08.34-.21.14-.13.21-.32.06-.18.06-.41 0-.45-.27-.72-.27-.27-.82-.27-.54 0-.82.27-.27.27-.27.72 0 .22.07.41.07.18.2.32.14.13.35.21.2.07.47.07Zm1.68 3.51q0-.18-.11-.3-.11-.11-.3-.18-.18-.06-.43-.09t-.53-.04q-.28-.02-.57-.03-.3-.01-.58-.05-.25.14-.4.33-.16.18-.16.43 0 .16.09.3.08.14.25.24.18.11.46.16.28.06.69.06.42 0 .72-.06.3-.07.49-.18.2-.11.29-.26.09-.15.09-.33Zm-.3-6.23h1.77v.56q0 .26-.32.32l-.55.1q.13.32.13.7 0 .45-.18.82-.19.37-.51.63-.33.26-.77.4t-.95.14q-.18 0-.35-.02-.16-.02-.33-.05-.28.18-.28.39 0 .19.17.28.17.08.45.12.28.04.64.04.36.01.74.04t.74.11q.36.07.64.24.28.16.45.44.17.28.17.71 0 .41-.2.8-.2.38-.58.68-.38.3-.93.48-.56.19-1.27.19-.69 0-1.21-.14-.52-.13-.86-.36-.34-.22-.51-.52-.17-.29-.17-.61 0-.43.27-.72.26-.29.71-.47-.24-.12-.39-.33-.14-.21-.14-.56 0-.13.05-.28.05-.15.15-.29.1-.15.25-.28.15-.12.35-.23-.47-.25-.73-.67-.27-.42-.27-.98 0-.46.18-.83.19-.37.51-.63.33-.26.78-.4.44-.13.97-.13.4 0 .75.08.34.08.63.23Z"
    />
  </svg>;
};

const AddJobNotes = ({ onClose, fetchNotes }) => {
  const navigate = useNavigate();
  const { jobId } = useParams();

  const formik = useFormik({
    initialValues: {
      note: "",
      images: [],
      is_show: false,
    },
    validationSchema: Yup.object().shape({
      note: stringValidationSchema,
    }),
    onSubmit: (values, { resetForm }) => {
      createNote(values, resetForm);
    },
  });

  const deleteImage = (removeIndex) => {
    formik.setFieldValue(
      "images",
      formik?.values?.images?.filter((_, index) => index !== removeIndex)
    );
  };

  const createNote = (data, resetForm) => {
    ApiClient.jobNote
      .post({ ...data, is_show: data?.is_show ? 1 : 2, ref_id: jobId })
      .then((res) => {
        if (res) {
          CustomToaster.success(res?.message);
          resetForm();
          fetchNotes();
          onClose();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Box sx={{ p: 2, position: "relative" }}>
        <Typography variant="h6" sx={{ fontSize: 18, mt: 1 }}>
          Note :
        </Typography>
        <CustomTextField
          form={formik}
          field={formik.getFieldProps("note")}
          // sx={{ height: "80px" }}
          multiline
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
            mt: 0,
          }}
        >
          <CustomCheckBox
            form={formik}
            name="is_show"
            label="Share with Client"
          />
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography variant="h6" sx={{ fontSize: 18, mt: 1 }}>
            Photos :
          </Typography>
          <CustomFileInput
            form={formik}
            multiple
            field={formik.getFieldProps("images")}
            customIcon={
              <Box
                sx={{
                  border: 0.5,
                  borderRadius: 1,
                  borderStyle: "dotted",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  p: 1,
                  width: "100%",
                  color: "#137ABF",
                }}
              >
                <UploadFile sx={{ mr: 1 }} />
                <Typography noWrap component={"strong"}>
                  Upload
                </Typography>
              </Box>
            }
          />
        </Box>

        <Grid container spacing={1} sx={{ overflow: "hidden", px: 1 }}>
          {formik.values?.images?.map((item, index) => {
            return (
              <Grid key={index} xs={4} item>
                <ImageListItem
                  sx={{
                    position: "relative",
                    borderRadius: 4,
                    ".MuiImageListItem-img": {
                      height: "100px",
                      objectFit: "fill",
                    },
                  }}
                  key={item.img}
                >
                  <CloseIcon
                    onClick={() => {
                      deleteImage(index);
                    }}
                    sx={{
                      width: 20,
                      height: 20,
                      position: "absolute",
                      top: -2.2,
                      right: -2.2,
                      backgroundColor: "#e5e5e5",
                      borderRadius: 100,
                      ":hover": {
                        cursor: "pointer",
                      },
                    }}
                  />
                  <img
                    style={{ borderRadius: 1, borderTopRightRadius: 6 }}
                    height={"100px"}
                    width={"100px"}
                    src={item?.fileurl}
                    alt={item?.filename}
                    loading="lazy"
                  />
                </ImageListItem>
              </Grid>
            );
          })}
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 16 }}>
          <CustomButton
            disabled={formik?.isSubmitting}
            onClick={formik.handleSubmit}
            sx={{
              position: {
                xs: "fixed",
                md: "relative",
                lg: "relative",
              },
            }}
            label="Submit"
          />
        </Box>
      </Box>
    </>
  );
};

const UpdateNote = ({ data = {}, onClose, fetchNotes }) => {
  const navigate = useNavigate();
  const { jobId } = useParams();

  const formik = useFormik({
    initialValues: {
      note: data?.note,
      images: data?.images,
      ...data,
      is_show: data?.is_show === 1 ? true : false,
    },
    validationSchema: Yup.object().shape({
      note: stringValidationSchema,
    }),
    onSubmit: (values, { resetForm }) => {
      createNote(values, resetForm);
    },
  });

  const deleteImage = (removeIndex) => {
    formik.setFieldValue(
      "images",
      formik?.values?.images?.filter((_, index) => index !== removeIndex)
    );
  };

  const createNote = (data, resetForm) => {
    ApiClient.jobNote
      .put(data?.id, {
        note: data?.note,
        images: data?.images,
        is_show: data?.is_show ? 1 : 2,
      })
      .then((res) => {
        if (res) {
          CustomToaster.success(res?.message);
          resetForm();
          onClose();
          fetchNotes();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Box sx={{ p: 2, position: "relative" }}>
        <Typography variant="h6" sx={{ fontSize: 18, mt: 1 }}>
          Note :
        </Typography>
        <CustomTextField
          form={formik}
          field={formik.getFieldProps("note")}
          // sx={{ minHeight: "a" }}
          multiline
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
            mt: 0,
          }}
        >
          <CustomCheckBox
            form={formik}
            name="is_show"
            label="Share with Client"
          />
        </Box>

        <Box sx={{ mb: 8 }}>
          <Typography variant="h6" sx={{ fontSize: 18, mt: 1 }}>
            Photos :
          </Typography>
          <CustomFileInput
            form={formik}
            multiple
            field={formik.getFieldProps("images")}
            customIcon={
              <Box
                sx={{
                  border: 0.5,
                  borderRadius: 1,
                  borderStyle: "dotted",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  p: 1,
                  width: "100%",
                  color: "#137ABF",
                }}
              >
                <UploadFile sx={{ mr: 1 }} />
                <Typography noWrap component={"strong"}>
                  <>Upload</>
                </Typography>
              </Box>
            }
          />
        </Box>

        <Grid container spacing={1} sx={{ overflow: "hidden", px: 1 }}>
          {formik.values?.images?.map((item, index) => {
            return (
              <Grid key={index} xs={4} item>
                <ImageListItem
                  sx={{
                    position: "relative",
                    borderRadius: 4,
                    ".MuiImageListItem-img": {
                      height: "100px",
                      objectFit: "fill",
                    },
                  }}
                  key={item.img}
                >
                  <CloseIcon
                    onClick={() => {
                      deleteImage(index);
                    }}
                    sx={{
                      width: 20,
                      height: 20,
                      position: "absolute",
                      top: -2.2,
                      right: -2.2,
                      backgroundColor: "#e5e5e5",
                      borderRadius: 100,
                      ":hover": {
                        cursor: "pointer",
                      },
                    }}
                  />
                  <img
                    style={{ borderRadius: 1, borderTopRightRadius: 6 }}
                    height={"100px"}
                    width={"100px"}
                    src={item?.fileurl}
                    alt={item?.filename}
                    loading="lazy"
                  />
                </ImageListItem>
              </Grid>
            );
          })}
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 16 }}>
          <CustomButton
            disabled={formik?.isSubmitting}
            onClick={formik.handleSubmit}
            sx={{
              position: {
                xs: "fixed",
                md: "relative",
                lg: "relative",
              },
            }}
            label="Submit"
          />
        </Box>
      </Box>
    </>
  );
};

export const JobNotes = () => {
  const [noteDetail, setNoteDetail] = useState(false);
  const { jobId } = useParams();
  const fetchNotes = () => {
    ApiClient.jobNote
      .get("?job_id=" + jobId)
      .then((res) => {
        if (res) {
          setNoteDetail(res?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  const handleDelete = (id, handleCloseSuccess) => {
    ApiClient.jobNote
      .delete(id)
      .then((res) => {
        if (res) {
          CustomToaster.success(res?.message);
          handleCloseSuccess();
          fetchNotes();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const RenderNoteCard = ({ item }) => {
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    function SwipeableTextMobileStepper({ images, item }) {
      const theme = useTheme();
      const [activeStep, setActiveStep] = React.useState(0);
      const maxSteps = images.length;

      const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      };

      const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };

      const handleStepChange = (step) => {
        setActiveStep(step);
      };

      return (
        <Box sx={{ flexGrow: 1 }}>
          <MobileStepper
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            nextButton={
              <Button
                size="small"
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                Next
                {theme.direction === "rtl" ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={handleBack}
                disabled={activeStep === 0}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
                Prev
              </Button>
            }
          />
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents
          >
            {images.map((step, index) => (
              <div key={step.label}>
                {Math.abs(activeStep - index) <= 2 ? (
                  <Box
                    component="img"
                    sx={{
                      // height: 255,
                      display: "block",
                      maxWidth: 500,
                      maxHeight: 500,
                      // overflow: "hidden",
                      width: "100%",
                      objectFit: "fill",
                      background: "#ccc",
                      p: 0.2,
                      borderRadius: 1,
                    }}
                    src={step.fileurl}
                    alt={step.filename}
                  />
                ) : null}
              </div>
            ))}
          </SwipeableViews>
        </Box>
      );
    }

    return (
      <>
        <Dialog
          maxWidth={"lg"}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 10,
                top: 8,
                // color: (theme) => theme.palette.grey[500],
              }}
            >
              <Close />
            </IconButton>
            <DialogContentText sx={{ mb: 4, mt: 3 }}>
              {item?.note}
            </DialogContentText>{" "}
            {item?.images?.length ? (
              <>
                <SwipeableTextMobileStepper images={item?.images} />
              </>
            ) : (
              <></>
            )}
          </DialogContent>
        </Dialog>
        <Box
          sx={{
            backgroundColor: "#f2f2f2",
            p: 1,
            borderRadius: 2,
            width: {
              xs: "100%",
              md: "48%",
              lg: "32%",
            },
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box component={"div"}>
            <Typography
              onClick={handleClickOpen}
              variant="body2"
              sx={{
                px: 1,
                // py: 0.8,
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
              }}
            >
              {item?.note}
            </Typography>
            <Typography
              onClick={handleClickOpen}
              noWrap
              variant="body2"
              sx={{
                px: 1,
                py: 0.8,
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              {/* <AttachFile />  */}
              Photos :{" "}
              <Typography variant="span" sx={{ fontWeight: "700" }}>
                {item?.images?.length}
              </Typography>
            </Typography>
          </Box>

          <Box>
            <Typography
              variant="body2"
              sx={{
                px: 1,
                textDecoration: "underline",
                color: colors.blue[700],
                ":hover": { cursor: "pointer" },
              }}
              onClick={handleClickOpen}
            >
              View full note
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ textTransform: "capitalize", fontSize: 10 }}
              >
                Posted by:{" "}
                {item?.sender_info?.first_name +
                  " " +
                  item?.sender_info?.last_name}
                , {dayjs(item?.created_at).format("MMM, DD-YYYY, hh:mma")}
                {item?.is_show == 1 ? (
                  <Typography
                    component={"span"}
                    sx={{
                      fontSize: 12,
                      background: colors.orange[100],
                      borderRadius: 1,
                      mx: 1,
                      p: 0.2,
                      px: 1,
                    }}
                  >
                    Visible to Client{" "}
                  </Typography>
                ) : (
                  ""
                )}
              </Typography>
              {item?.sender_id === GET_USER?.id ? (
                <CustomPopover>
                  <CustomDialogWrapper
                    fullWidth
                    title="Edit Note"
                    element={
                      <ListItemButton
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Edit />
                        <Typography component={"span"}>Edit</Typography>
                      </ListItemButton>
                    }
                  >
                    <UpdateNote fetchNotes={fetchNotes} data={item} />
                  </CustomDialogWrapper>
                  <DeleteConfirmationDialog
                    onSubmit={handleDelete}
                    id={item?.id}
                  >
                    <ListItemButton
                      sx={{
                        color: "red",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Delete />
                      <Typography component={"span"}>Delete</Typography>
                    </ListItemButton>
                  </DeleteConfirmationDialog>
                </CustomPopover>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Box>
      </>
    );
  };

  return (
    <>
      <Box sx={{ p: 1, position: "relative" }}>
        <CustomDialogWrapper
          fullWidth
          title="Add Note"
          element={
            <Box
              sx={{
                border: 0.5,
                borderRadius: 1,
                borderStyle: "dotted",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                py: 1,
                my: 1,
                width: {
                  lg: "20%",
                },
                ":hover": {
                  cursor: "pointer",
                },
                color: ThemeColors.secondaryText,
                // background:colors.green[600]
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: 18,
                  mt: 0.5,
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <Add /> Add Note
              </Typography>
            </Box>
          }
        >
          <AddJobNotes fetchNotes={fetchNotes} />
        </CustomDialogWrapper>

        <Box
          sx={{
            display: {
              xs: "auto",
              md: "flex",
            },
            flexWrap: "wrap",
            gap: 1.6,
          }}
        >
          {noteDetail ? (
            <>
              {noteDetail?.length ? (
                <>
                  {noteDetail?.map((item) => (
                    <RenderNoteCard key={item.id} item={item} />
                  ))}
                </>
              ) : (
                <>
                  <NoResultFound>No Notes To Show</NoResultFound>
                </>
              )}
            </>
          ) : (
            <LoadingEffect />
          )}
        </Box>
      </Box>
    </>
  );
};
